export default {
  dashboard: 'Resumen',
  system_manage: 'Gestión del sistema',
  simulation_manage: 'Gestión de simulaciones de pago',
  account_settings: 'Configuración de la cuenta',
  simulation_payment: 'Simulación de pago mediante código QR estático',
  simulation_dynamic_payment: 'Simulación de pago mediante orden dinámica',
  simulation_qr_payment: 'Simulación de pago mediante Código QR',
  simulation_bank_transfer_payment: 'Simulación de pago por transferencia bancaria',
  simulation_payout: 'Simulación de desembolso / Payout',
  simulation_checkout_payment: 'Simulación de pago mediante orden de checkout',
  simulation_refund: 'Simulación de reembolso',
  customerService_manage: 'Atención al cliente',
  transaction_manage: 'Gestión de transacciones',
  refund_transaction_query: 'Consulta de reembolsos',
  customerService_manage_query_pay: 'Consulta de operaciones de cobro (Pay-in)',
  customerService_manage_query_payout: 'Consulta de operaciones de pago (Payout)',
  customer_service_ticket_list: 'Gestión de tickets',
  customer_service_manage_query_card_verification: 'Consulta de verificación de tarjetas',
  develop_manage: 'Desarrollador',
  application_manage_list: 'Configuración de aplicaciones',
  application_manage_detail: 'Detalles de la aplicación',
  institute_plan_template: 'Plantilla de combinación de intereses y comisiones',
  user_list: 'Gestión de usuarios',
  role_list: 'Gestión de roles',
  financial: 'Gestión de fondos',
  financial_setting: 'Configuración de fondos',
  payin: 'Transacciones de cobro',
  payout: 'Transacciones de pago',
  loan: 'Transacciones de préstamo',
  repayment: 'Transacciones de reembolso',
  balance: 'Gestión de saldos',
  account_balance: 'Saldo de la cuenta',
  balance_details: 'Detalles del saldo',
  top_up: 'Recargar',
  questionnaire: 'Cuestionario AML (Antilavado de dinero)',
  deposits: 'Depósitos',
  transaction_summary: 'Resumen de transacciones',
  send_payments: 'Enviar pagos',
  online_payment: 'Enlaces de pago',
  online_payout: 'Pago de bajo valor',
  online_large_payout: 'Beneficiarios de alto valor',
  payout_payment: 'Pagos',
  large_value_payment: 'Pago de alto valor',
  payment_link: 'Enlaces de pago',
  reference_detail: 'Detalle del lote',
  link_transaction_detail: 'Detalles de transacción por enlace',
  payout_approval: 'Aprobación de pago',
  payment_page: 'Página de pago',
  edit_payment_information: 'Editar información de cobro',
  checking_order: 'Gestión de transacciones',
  link_information: 'Gestión de páginas',
  create_mch_code: 'Creación de código de comercio',
  qr_stand: 'Código QR de cobro',
  qr_stand_list: 'Lista de códigos QR de cobro',
  supplementary_info: 'Información complementaria',
  va_collection: 'Cobros por VA (Cuenta Virtual)',
  va_account: 'Cuentas Virtuales (VA)',
  va_collection_query: 'Consulta de transacciones VA',
  merchant_list: 'Lista de comercios',
  merchants: 'Gestión de comercios',
  refund: 'Transacciones de reembolso',
  notifications: 'Notificaciones',
  checkout: 'Checkout',
  orders: 'Lista de órdenes',
  batch_payment_details: 'Historial de cargas por lotes',
  fx_transactions: 'Transacciones de cambio de divisas (FX)',
  fx_query: 'Consulta de cambio de divisas',
  split_transaction: 'Transacción de reparto de fondos (Split)',
  card_verification_list: 'Lista de verificación de tarjetas',
  service_provider_tools: 'Herramientas de proveedor de servicios',
  transaction_records: 'Historial de transacciones',
  static_qr: 'Código QR estático',
  accept_payments: 'Herramientas de cobro',
  operation_manage: 'Gestión operativa',
  business_manage: 'Gestión de negocios',
  franchisee_manage: 'Gestión de franquiciados',
  franchisee_create: 'Crear franquiciado',
  franchisee_edit: 'Editar franquiciado',
  franchisee_detail: 'Detalles del franquiciado'
}
